import { postUniversalMessage } from "@jack-henry/banno-plugin-framework-bridge";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MOBILEREGEX =
  /(android|bb\d+|meego).+mobile|avantgo|bada|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|iphone|ipod|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera mobi|palm os?|phone|pixi|pre|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
const MOBILEREGEXSUBSTR =
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|awa|abac|acer|acoo|ac-s|aiko|airn|alav|alca|alco|amoi|anex|anyw|aptu|arch|argo|aste|asus|attw|audi|awm|au-s|avan|beck|bell|nq|bilb|blac|blaz|bumb|bw-n|c55|capi|ccwa|cdm|cell|chtm|cldc|cmd|com|craw|dait|dbte|dc-s|devi|dica|dmob|doco|ds12|ds-d|el49|eml2|emul|eric|esl8|ez40|ezos|ezwa|fetc|flyg1u|g560|gf5|gmo|gow|god|grun|grun|hcit|hd-m|hd-p|hd-t|heia|hipt|hita|hpit|hpip|hsc|hts|huaw|hutc|i-20|igo|i230|iac-|iac\/|ibro|idea|ig01|ikom|imk|inno|ipaq|iris|jaav|jbro|jemu|jigs|kddi|keji|kgt|klon|kpt|kwc|kyoc|leix|lgk|lg50|libw|lynx|m1-w|m3ga|m50|mate|mte|mmi|mwbp|mywa|n10|n20|n30|necm|neon|nok|o2im|opti|pdxg|pg13|phic|pluc|pn2|poco|prox|psio|pt-g|qa-a|qc07|qc32|qtek|rim9|rozo|saem|sc01|sdk|se01|sgh|shar|sie|sk0|slid|smap|sonf|sp01|sy01|t18|tcl|tdg|tel|timo|to-p|ts70|tx9|upbg|upsi|utst|v400|v750|veri|virg|vks|vm40|voda|vulc|vx52|vx80|webc|wmlb|wonu|x700|yas|zeto|zte/i;


export const isSMSCapable = () => {
  const os = getOS();
  const browser = navigator.userAgent;
  let isMobile = false;
  let SMScapable = false;

  if (MOBILEREGEX.test(browser) || MOBILEREGEXSUBSTR.test(browser.slice(0, 4))) {
    isMobile = true;
  }
  if (isMobile || os === "macos" || os === "ios") {
    SMScapable = true;
  }
  console.log("IS MOBILE", isMobile);
  console.log("IS SMS CAPABLE", SMScapable);
  return SMScapable;
};


export const stddatetime = (date) => {
  const month = months[date.getMonth()];
  const day = date.getDate();
  let hours = date.getHours();
  let am_pm = "AM";
  const minutes = "0" + date.getMinutes();
  if (hours === 0) {
    hours = 12;
  } else if (hours === 12) {
    am_pm = "PM";
  } else if (hours > 12) {
    am_pm = "PM";
    hours -= 12;
  }
  return (
    month + " " + day + " " + hours + ":" + minutes.slice(-2) + " " + am_pm
  );
};

export const yearMonthDate = (date) => {
  const year = date.getFullYear();
  const month = months[date.getMonth()];
  const day = date.getDate();
  return year + " " + month + " " + day;
};

export const monthDateYear = (date) => {
  const year = date.getFullYear();
  const month = months[date.getMonth()];
  const day = date.getDate();
  return month + " " + day + ", " + year;
};

export const displayTransferRecipient = (recipient, shouldShorten, transfer = null) => {
  switch (recipient.type) {
    case "email":
    case "pushtocard": {
      if (recipient.value.length > 25 && shouldShorten && isMobile()) {
        return `${recipient.value.slice(0, 25)}...`;
      } else {
        return recipient.value;
      }
    }
    case "phone": {
      return `(${recipient.value.slice(-10, -7)}) ${recipient.value.slice(-7, -4)}-${recipient.value.slice(-4)}`;
    }
    case "pushtoaccount": {
      // Display "Sent to Account for [Name]" if name is available, otherwise "Sent to Account"
      if (transfer && (transfer.recipient_first_name || transfer.recipient_last_name)) {
        const firstName = transfer.recipient_first_name || "";
        const lastName = transfer.recipient_last_name || "";
        const fullName = `${firstName} ${lastName}`.trim();
        return `Sent to Account for ${fullName}`;
      } else {
        return "Sent to Account";
      }
    }
    default:
      return recipient.value;
  }
};

export const displayTransferStatus = (transfer) => {
  switch (transfer.status) {
    case "SUCCEEDED": {
      switch (transfer.outgoing) {
        case false: {
          return "Received";
        }
        default:
          return "Sent";
      }
    }
    default:
      return transfer.status.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
  }
};

export const getOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase(),
    macosPlatforms = /(mac)/i,
    windowsPlatforms = /(win32|win64|windows|wince)/i,
    iosPlatforms = /(iphone|ipad|ipod)/i;

  let os = null;

  if (macosPlatforms.test(userAgent)) {
    os = "macos";
  } else if (iosPlatforms.test(userAgent)) {
    os = "ios";
  } else if (windowsPlatforms.test(userAgent)) {
    os = "windows";
  } else if (/android/.test(userAgent)) {
    os = "android";
  } else if (!os && /linux/.test(userAgent)) {
    os = "linux";
  } else {
    os = "unknown";
  }

  return os;
};

export const isMobile = () => {
  return /Android|Windows Phone|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mobile|Tablet|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const deviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

/**
 * Uses the banno plugin bridge click-link app event to open link in an external browser.
 * This is useful when you need to send a sms message. If the postUniversalMessage is unsuccessful
 * It will fallback to setting the sms as a href. This is useful if you in a banno flow
 * but in a new tab and cant send messages to a parent frame.
 * @param {string} href - The link you want to send the user to
 * @param {boolean} external - If you want to open this in a new tab/out of the mobile app
 * @returns Opens link in banno environment
 */
export const hrefRouter = (href, external) => {
  const messageSent = postUniversalMessage({
    type: "click-link",
    data: { href: href, external: external },
  });
  // Message was not sent. Fallback to setting window href
  if (!messageSent) {
    window.location.href = href;
  }
};
